module.exports = __webpack_public_path__ + "img/umbrella.67e17f4c.png";